module.exports = __webpack_public_path__ + "static/img/4.33e2ccda.png";